import { AutogenModelStatetax, AutogenRowStatetax } from "./autogen/AutogenModelStatetax";

export class ModelStatetax extends AutogenModelStatetax<RowStatetax> {
	constructor() {
		super(RowStatetax);
	}
}

export class RowStatetax extends AutogenRowStatetax {
}